import {
  Box,
  Button,
  Checkbox,
  Flex,
  IconButton,
  Td,
  Text,
  Tr,
  useColorModeValue,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import {
  AddIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  DeleteIcon,
  EditIcon,
} from "@chakra-ui/icons";
import { IoIosSend } from "react-icons/io";
import { TbApi } from "react-icons/tb";
import AddSMTPServerDialog from "./AddSMTPServerDialog";
import { axiosPost } from "utils/api";
import { ROOT_API } from "utils/constant";
import { API_ROUTES } from "utils/constant";
import ExpandedRow from "./ExpandedRow";
import AddBackupEmail from "./AddBackupEmail";
import SendEmailTestModal from "./SendEmailTestModal";
import SendEmailApiTestModal from "./SendEmailApiTestModal";
import { FaExchangeAlt } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { MdChangeCircle } from "react-icons/md";

function SMTPRow(props) {
  const { setting, isLast, refetch } = props;
  const textColor = useColorModeValue("gray.500", "white");
  const titleColor = useColorModeValue("gray.700", "white");
  const bgStatus = useColorModeValue("gray.400", "navy.900");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const history = useHistory();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenBackup,
    onOpen: onOpenBackup,
    onClose: onCloseBackup,
  } = useDisclosure();
  const {
    isOpen: isOpenSendMailModal,
    onOpen: onOpenSendMailModal,
    onClose: onCloseSendMailModal,
  } = useDisclosure();
  const {
    isOpen: isOpenSendMailApiModal,
    onOpen: onOpenSendMailApiModal,
    onClose: onCloseSendMailApiModal,
  } = useDisclosure();

  const [expandedRows, setExpandedRows] = useState([]);
  const toast = useToast();
  const toggleRow = (id) => {
    if (expandedRows.includes(id)) {
      setExpandedRows(expandedRows.filter((rowId) => rowId !== id));
    } else {
      setExpandedRows([...expandedRows, id]);
    }
  };
  function handleRowClick() {
    onOpen();
  }
  async function handleActiveServer() {
    if (window.confirm("Are you sure to change status for this STMP server")) {
      const serverData = {
        id: setting._id,
      };
      try {
        const data = await axiosPost(
          ROOT_API + API_ROUTES.SMTP_SERVER_UPDATE_STATUS,
          serverData
        );
        if (data?.data?.code == 0) {
          toast({
            title: "Update SMTP Server 's status Successfully",
            status: "success",
            duration: 9000,
            isClosable: true,
          });
          refetch();
        }
      } catch (error) {
        // console.log(error)
        toast({
          title:
            error?.response?.data?.errors?.errors[0]?.msg ||
            error?.response?.data?.msg ||
            "Update SMTP Server 's status Fail",
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
    }
  }
  async function handleDeleteClick() {
    if (window.confirm("Are you sure to delete this STMP server")) {
      const serverData = {
        id: setting._id,
      };
      try {
        const data = await axiosPost(
          ROOT_API + API_ROUTES.SMTP_SERVER_DELETE,
          serverData
        );
        if (data?.data?.code == 0) {
          toast({
            title: "Delete SMTP Server Successfully",
            status: "success",
            duration: 9000,
            isClosable: true,
          });
          refetch();
        }
      } catch (error) {
        // console.log(error)
        toast({
          title:
            error?.response?.data?.errors?.errors[0]?.msg ||
            error?.response?.data?.msg ||
            "Delete SMTP Server Fail",
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
    }
  }

  const handleChangeLimit = async (e, idEmail) => {
    e.stopPropagation();
    if (window.confirm("Are you sure to change the limit for this email")) {
      try {
        const dataPayload = {
          id: setting?._id,
        };
        const response = await axiosPost(
          ROOT_API + API_ROUTES.CHANGE_LIMIT,
          dataPayload
        );
        if (response?.data?.code == 0) {
          toast({
            title: "Change limit email Backup Successfully",
            status: "success",
            duration: 9000,
            isClosable: true,
          });
          refetch();
        }
      } catch (error) {
        console.log(error);
        toast({
          title:
            error?.response?.data?.errors?.errors[0]?.msg ||
            error?.response?.data?.msg ||
            "Change limit email Backup Fail",
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
    }
  };

  const handleChangeBlock = async (e) => {
    e.stopPropagation();
    if (window.confirm("Are you sure to change status block for this email")) {
      try {
        const dataPayload = {
          id: setting?._id,
        };
        const response = await axiosPost(
          ROOT_API + API_ROUTES.BLOCK_EMAIL,
          dataPayload
        );
        if (response?.data?.code == 0) {
          toast({
            title: "Change status block Successfully",
            status: "success",
            duration: 9000,
            isClosable: true,
          });
          refetch();
        }
      } catch (error) {
        console.log(error);
        toast({
          title:
            error?.response?.data?.errors?.errors[0]?.msg ||
            error?.response?.data?.msg ||
            "Change status block Fail",
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
    }
  };

  return (
    <>
      <Tr>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Text
            fontSize="md"
            color={titleColor}
            fontWeight="bold"
            minWidth="100%"
          >
            {setting?.brand}
          </Text>
        </Td>

        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Text fontSize="md" color={textColor} fontWeight="bold">
            {setting?.port}
          </Text>
        </Td>
        {/* <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Text fontSize="md" color={textColor} fontWeight="bold">
            {setting?.secure ? "Secure" : "Insecure"}
          </Text>
        </Td> */}
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Text fontSize="md" color={textColor} fontWeight="bold">
            {setting?.authUserEmail}
          </Text>
          <Text fontSize="md" color={textColor} fontWeight="bold">
            {setting?._id}
          </Text>
        </Td>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Text fontSize="md" color={textColor} fontWeight="bold">
            {setting?.authUserPassword}
          </Text>
        </Td>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Text fontSize="md" color={textColor} fontWeight="bold">
            {setting?.totalEmailSended}
          </Text>
        </Td>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Text fontSize="md" color={textColor} fontWeight="bold">
            {setting?.mailSentInDay}
          </Text>
        </Td>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Text fontSize="md" color={textColor} fontWeight="bold">
            {setting?.isLimit ? "Yes" : "No"}
          </Text>
        </Td>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Text fontSize="md" color={textColor} fontWeight="bold">
            {setting?.isBlocked ? "Blocked" : "Unblocked"}
          </Text>
        </Td>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Flex flexDirection={"row"} alignItems={"center"} columnGap={2}>
            <Checkbox
              id={setting._id}
              value={setting.isActive}
              isChecked={setting.isActive}
              onChange={handleActiveServer}
            />
            <Text
              fontSize="md"
              color={setting.isActive ? "red" : "green"}
              fontWeight="bold"
              textTransform={"capitalize"}
            >
              Active
            </Text>
          </Flex>
        </Td>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Flex direction={"row"} columnGap={1}>
            <Button
              ml={2}
              p="0px"
              bg="transparent"
              variant="no-effects"
              onClick={() => onOpenBackup()}
            >
              <AddIcon />
            </Button>
            {setting.backupEmails?.length ? (
              <Box as="tr">
                <IconButton
                  icon={
                    expandedRows?.includes(setting._id) ? (
                      <ChevronDownIcon />
                    ) : (
                      <ChevronUpIcon />
                    )
                  }
                  onClick={() =>
                    history.push(`/admin/backup-email/${setting?.brand}`)
                  }
                  aria-label={
                    expandedRows?.includes(setting?._id)
                      ? "Hide details"
                      : "Show details"
                  }
                />
              </Box>
            ) : (
              ""
            )}
            {/* {setting.backupEmails?.length ? (
              <Box as="tr">
                <IconButton
                  icon={
                    expandedRows?.includes(setting._id) ? (
                      <ChevronDownIcon />
                    ) : (
                      <ChevronUpIcon />
                    )
                  }
                  onClick={() => toggleRow(setting._id)}
                  aria-label={
                    expandedRows?.includes(setting?._id)
                      ? "Hide details"
                      : "Show details"
                  }
                />
              </Box>
            ) : (
              ""
            )} */}
          </Flex>
        </Td>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Flex>
            <Button
              p="0px"
              bg="transparent"
              variant="no-effects"
              onClick={handleChangeBlock}
            >
              <MdChangeCircle size={22} color="#4299e1" />
            </Button>
            <Button
              p="0px"
              bg="transparent"
              variant="no-effects"
              onClick={handleChangeLimit}
            >
              <FaExchangeAlt size={16} color="#4299e1" />
            </Button>
            <Button
              p="0px"
              bg="transparent"
              variant="no-effects"
              onClick={() => {
                onOpenSendMailApiModal();
              }}
            >
              <TbApi size={16} color="#4299e1" />
            </Button>
            <Button
              p="0px"
              bg="transparent"
              variant="no-effects"
              onClick={() => {
                onOpenSendMailModal();
              }}
            >
              <IoIosSend size={16} color="#4299e1" />
            </Button>
            <Button
              p="0px"
              color="blue.400"
              bg="transparent"
              variant="no-effects"
              onClick={() => handleRowClick()}
            >
              <EditIcon />
            </Button>
            <Button
              p="0px"
              color="red.400"
              bg="transparent"
              variant="no-effects"
              onClick={() => handleDeleteClick()}
            >
              <DeleteIcon />
            </Button>
          </Flex>
        </Td>
      </Tr>
      <AddSMTPServerDialog
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        fetchData={refetch}
        smtpSetting={setting}
      />
      <AddBackupEmail
        isOpen={isOpenBackup}
        onOpen={onOpenBackup}
        onClose={onCloseBackup}
        fetchData={refetch}
        smtpId={setting._id}
      />
      {isOpenSendMailModal && (
        <SendEmailTestModal
          isOpen={isOpenSendMailModal}
          onOpen={onOpenSendMailModal}
          onClose={onCloseSendMailModal}
          fetchData={refetch}
          smtpId={setting._id}
        />
      )}
      {isOpenSendMailApiModal && (
        <SendEmailApiTestModal
          isOpen={isOpenSendMailApiModal}
          onOpen={onOpenSendMailApiModal}
          onClose={onCloseSendMailApiModal}
          brand={setting.brand}
          fetchData={refetch}
          smtpId={setting._id}
        />
      )}
      {expandedRows.includes(setting?._id) && (
        <Tr>
          <Td colSpan={8}>
            <ExpandedRow
              emailBackup={setting?.backupEmails}
              refetch={refetch}
              smtpId={setting._id}
            />
          </Td>
        </Tr>
      )}
    </>
  );
}

export default SMTPRow;
